import SidebarSearch from './SidebarSearch.container'

export default SidebarSearch
